<header class="justify-items-around fixed-top-header mx-auto"
>
  <!-- style="z-index: 10;fixed-top" -->
  <div
    id="section-top-header"
    [ngStyle]="{ 'background-color': sectionHeader?.background_header }"
  >
    <div class="d-flex justify-content-between align-items-center w-100 mx-auto" style="max-width: 1440px;">
      <div
        class="d-flex justify-content-start align-items-center text-truncate align-self-center px-0"
        style="height: 35px !important; right: 50px"
      >
        <ul class="nav justify-content-xg-end justify-content-lg-end">
          <li class="nav-item d-flex align-items-center" style="gap: 5px">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 226.8 226.7"
              style="fill: #c5c5c5; width: 15px; height: 15px"
              xml:space="preserve"
            >
              <path
                d="M156.4,226.7c-3.8-0.6-7.7-1.1-11.5-1.9c-10.2-2.1-19.7-6.1-29-10.6c-36.7-18.1-66.1-44.6-89-78.4 C16.8,121.2,9,105.3,3.7,88.4c-3.1-9.9-4.9-19.9-2.8-30.3c0.9-4.8,3.2-9.3,6.6-12.8c6-6.1,12-12.2,18.2-18.1 c7.7-7.4,16.4-7.4,24.1,0.1c9,8.8,17.8,17.7,26.6,26.6c3.9,4,6.5,8.6,5.6,14.5c-0.6,4.4-3.1,7.7-6.2,10.7c-5,5-10,10-15.1,15 c-2.6,2.6-2.7,3.3-1.2,6.6c5.7,12.8,14.5,23.4,23.8,33.6c9.2,10.2,19.7,19.1,31.3,26.5c4,2.5,8.3,4.5,12.4,6.8 c1.9,1,3.4,0.2,4.7-1.1c5.1-5.2,10.3-10.4,15.5-15.5c1.6-1.6,3.3-3,5.1-4.1c5.9-3.6,12.5-3,17.9,1.4c1.1,0.9,2.1,1.8,3.1,2.8 c8.4,8.3,16.8,16.6,25,25.1c2.1,2.1,3.8,4.5,5.1,7.1c2.6,5.2,1.6,11.5-2.4,15.7c-6.5,7.2-13.5,14.1-20.5,20.9 c-3.8,3.7-8.8,5.6-14.1,6.5c-0.6,0.1-1.3,0.3-1.9,0.5L156.4,226.7z"
              />
              <path
                d="M226.8,106.2l-17.4,3.1C205,85.4,194.3,65,177,48.1s-38.1-27-62.4-30.6c0.8-5.8,1.6-11.6,2.4-17.4 c10.8,1.5,21.4,4.3,31.5,8.5c18.6,7.7,35.2,19.6,48.4,34.9c12.9,14.7,22.2,32.2,27.2,51.1c1,3.6,1.8,7.3,2.7,10.9L226.8,106.2z"
              />
              <path d="M114.7,45.4c30.7,3.5,60.1,28.6,66,63.9l-17.3,3c-4.5-25.9-25.1-45.9-51.1-49.6C113.1,56.9,113.9,51.1,114.7,45.4z" />
            </svg>
            <p class="mb-0 header-item--text">&nbsp;{{ getClientsSettingAppBooking?.phone_number_one }}</p>
          </li>
          <li class="nav-item ml-3 pl-2 align-items-center justify-content-center" style="border-left: 1px solid #ffffff; margin: 5px 0px">
            <a href="https://help.fusionpax.com/" target="_blank" class="mx-2" title="help">
              <svg
                style="width: 20px; height: 20px"
                [ngStyle]="{ fill: getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 226.8 226.8"
              >
                <path
                  d="M195,0H31.84A31.83,31.83,0,0,0,0,31.86V139.53a31.84,31.84,0,0,0,31.84,31.84H63.68v43.76a11.63,11.63,0,0,0,19,9l52.51-52.72H195a31.84,31.84,0,0,0,31.84-31.84V31.86A31.83,31.83,0,0,0,195,0Z"
                />
                <path
                  style="fill: #000000"
                  d="M113.19,116.7h0a9,9,0,0,1-9-9h0v-3.13q0-6.11,2.48-9.64t10.85-10q12.8-9.84,12.79-20.82,0-8.28-5-13.15t-13-4.9q-15.09,0-20.06,17a10.06,10.06,0,0,1-11.42,7h0A10.09,10.09,0,0,1,72.65,58.3a11.38,11.38,0,0,1,.27-1.12,40.7,40.7,0,0,1,12-19.08Q97.3,27.17,114.57,27.16T143,37.39a33,33,0,0,1,11.27,25.45,34.3,34.3,0,0,1-3.11,14.38,33.59,33.59,0,0,1-7.08,10.54q-4,3.73-16.76,13.08c-2.4,1.75-3.93,3.44-4.6,5.09a13.1,13.1,0,0,0-.65,3A9,9,0,0,1,113.19,116.7Z"
                />
                <circle style="fill: #000000" class="cls-2" cx="113.37" cy="135.11" r="10.59" />
              </svg>
            </a>
          </li>
        </ul>
      </div>
      <div class="d-flex justify-content-end text-truncate align-self-center px-0" style="height: 35px !important">
        <ul class="nav justify-content-end">
          <!-- INSTAGRAM -->
          <li
            class="nav-item ml-3 mt-1 align-items-center d-flex"
            *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[1]?.url != ''"
          >
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[1]?.url" target="_blank" rel="noopener noreferrer">
              <svg
                style="width: 18px; height: 18px"
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 226.8 226.8"
              >
                <defs>
                  <style>
                    .cls-1 {
                      fill: #979797;
                    }
                  </style>
                </defs>
                <rect class="cls-1" width="226.8" height="226.8" rx="37.12" />
                <path d="M156.39,61.2a9.52,9.52,0,1,0,9.53,9.52A9.52,9.52,0,0,0,156.39,61.2Z" />
                <path
                  d="M114.07,73.41a40,40,0,1,0,40,40A40,40,0,0,0,114.07,73.41Zm0,65.61a25.62,25.62,0,1,1,25.62-25.62A25.65,25.65,0,0,1,114.07,139Z"
                />
                <path
                  d="M145.82,194.6H81A48.83,48.83,0,0,1,32.2,145.82V81A48.83,48.83,0,0,1,81,32.2h64.84A48.83,48.83,0,0,1,194.6,81v64.84A48.83,48.83,0,0,1,145.82,194.6ZM81,47.48A33.53,33.53,0,0,0,47.48,81v64.84A33.53,33.53,0,0,0,81,179.32h64.84a33.53,33.53,0,0,0,33.5-33.5V81a33.53,33.53,0,0,0-33.5-33.5Z"
                />
              </svg>
            </a>
          </li>
          <!-- LINKEDIN -->
          <li
            class="nav-item ml-2 mt-1 align-items-center d-flex"
            *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url != ''"
          >
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url" target="_blank" rel="noopener noreferrer">
              <svg
                style="width: 18px; height: 18px"
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 226.8 226.8"
              >
                <defs>
                  <style>
                    .cls-1 {
                      fill: #979797;
                    }
                  </style>
                </defs>
                <rect class="cls-1" width="226.8" height="226.8" rx="37.12" />
                <path d="M52.65,92.34H78.72v83.74H52.65Zm13-41.62A15.1,15.1,0,1,1,50.58,65.8,15.09,15.09,0,0,1,65.69,50.72" />
                <path
                  d="M95.05,92.34h25v11.45h.34c3.48-6.59,12-13.53,24.65-13.53,26.35,0,31.21,17.34,31.21,39.89v45.93h-26V135.36c0-9.72-.19-22.2-13.53-22.2-13.55,0-15.61,10.57-15.61,21.49v41.43h-26Z"
                />
              </svg>
            </a>
          </li>
          <li *ngIf="executiveData" class="nav-item help-container px-3 ml-3 align-items-center d-flex" style="gap: 5px; margin: 5px 0px">
            <svg
              class="header-item--icon"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 226.8 226.7"
              xml:space="preserve"
            >
              <path
                d="M202.5,128.3v88.6c0,6.9-2.9,9.9-9.8,9.9c-42.5,0-85,0-127.5,0c-22.4,0.1-40.7-17.9-40.8-40.3c0-0.1,0-0.3,0-0.4 c0-59,0-117.9,0-176.9c0-5.9,3.2-9.1,9-9.1c42.8,0,85.5,0,128.3,0c23,0,40.8,17.9,40.9,41C202.5,70.1,202.5,99.2,202.5,128.3z M186.3,210.5v-2.9c0-55.2,0-110.5,0-165.8c0-15.4-10.3-25.7-25.7-25.7c-39,0-78.1,0-117.2,0h-2.9v3c0,55.2,0,110.3,0,165.5 c0,15.5,10.3,25.8,25.8,25.8L186.3,210.5L186.3,210.5z"
              />
              <path
                d="M113.6,51.4h39.2c5.4,0,9.1,3.3,9.1,8s-3.6,8.1-9,8.2c-26.4,0-52.8,0-79.2,0c-5.3,0-9-3.4-9-8.2s3.7-8,9.1-8L113.6,51.4z"
              />
              <path
                d="M113.4,87.3c13.3,0,26.6,0,40,0c6.2,0,10.3,5.8,7.9,11.3c-1.6,3.5-4.5,5-8.4,4.9c-24.4,0-48.7,0-73.1,0c-2.2,0-4.4,0-6.6,0 c-4.9-0.1-8.5-3.6-8.4-8.2c0-4.5,3.7-8,8.1-8c0.1,0,0.2,0,0.3,0C86.6,87.3,100,87.3,113.4,87.3z"
              />
              <path
                d="M113.6,123.2c13.1,0,26.1,0,39.2,0c5.4,0,9.1,3.3,9.1,8c0,4.7-3.6,8.1-9,8.1c-26.4,0-52.8,0-79.2,0c-5.3,0-9-3.4-9-8.2 s3.7-8,9.1-8C87.1,123.2,100.4,123.2,113.6,123.2z"
              />
              <path d="M113.6,159.1h39.2c5.4,0,9.1,3.3,9.1,8s-3.6,8.1-9,8.2H73.8c-5.3,0-9-3.4-9-8.2s3.7-8,9.1-8L113.6,159.1z" />
            </svg>
            <p class="mb-0 header-item--text semi-bold" style="cursor: pointer" (click)="openModalFormOffline()">Formulario offline</p>
          </li>
          <li class="nav-item px-3 align-items-center d-flex" style="gap: 5px; margin: 5px 0px">
            <svg
              class="header-item--icon"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 226.8 226.7"
              xml:space="preserve"
            >
              <path
                d="M99,117.4c-19.1,0-38.1,0-57.2,0c-6.4,0-10.6-5.8-8.2-11.4c1.3-3.3,4.5-5.3,8-5.1h22.9c30.5,0,61,0,91.5,0 c6.4,0,10.6,5.6,8.4,11.3c-1.3,3.3-4.3,5.2-8.4,5.2H99z"
              />
              <path
                d="M99,146.3c-19.1,0-38.1,0-57.2,0c-6.4,0-10.6-5.8-8.2-11.4c1.3-3.3,4.5-5.3,8-5.1h22.9c30.5,0,61,0,91.5,0 c6.4,0,10.6,5.6,8.4,11.3c-1.3,3.3-4.3,5.2-8.4,5.2c-17.5,0-35,0-52.6,0L99,146.3z"
              />
              <path
                d="M99,88.6c-19.1,0-38.1,0-57.2,0c-6.4,0-10.6-5.8-8.2-11.4c1.3-3.3,4.5-5.3,8-5.1h22.9c30.5,0,61,0,91.5,0 c6.4,0,10.6,5.6,8.4,11.3c-1.3,3.3-4.3,5.2-8.4,5.2c-17.5,0-35,0-52.6,0H99z"
              />
              <path
                d="M226.8,30.5c0-14.6-9.8-24.3-24.4-24.3h-70.6c-26.5,0-52.9,0-79.4,0c-11.8,0-21.2,7.9-23.1,19.4c-0.4,3.2-0.5,6.3-0.6,9.5 c-2.3,0-4.3,0-6.4,0c-10.8,0.2-20,8-21.8,18.7C0.1,57.3-0.1,61,0,64.7V124c0,11.9,0,23.7,0,35.6c0,14.2,9.6,23.9,24,23.9 c13.1,0,26.1,0,39.2,0c1.7-0.2,3.3,0.6,4.3,2c7.3,9.8,14.7,19.4,22.1,29.1c6.2,8.2,15.1,8.1,21.1-0.3c6.8-9.5,13.5-19,20.2-28.6 c0.9-1.5,2.5-2.3,4.2-2.2c13.2,0.1,26.4,0.1,39.7,0c11.5,0,20.2-7.1,22.6-18.3c0.4-2.1,0.6-4.2,0.9-6.4h4c15,0,24.7-9.7,24.7-24.6 C226.8,99.5,226.8,65,226.8,30.5z M181.4,159.1c0,5.5-2.3,7.8-7.8,7.8c-14.2,0-28.3,0.1-42.5,0c-4.6-0.2-9,2.1-11.5,6 c-4.9,7.2-10,14.4-15,21.6c-3.7,5.3-5.9,5.3-9.7,0.3c-5.6-7.4-11.2-14.8-16.7-22.3c-2.5-3.7-6.7-5.8-11.2-5.6 c-14.3,0.1-28.5,0-42.8,0c-5.3,0-7.7-2.4-7.7-7.7c0-13.1,0-26.1,0-39.2V67.4c0.1-2.6,0-5.2,0-7.8c0-5.9,2.2-8.1,8-8.1h148.9 c5.7,0,8,2.2,8,7.9C181.4,92.6,181.4,125.9,181.4,159.1z M201,142.2h-3.1v-3.4c0-26.4,0-52.9,0-79.3c0-14.9-9.6-24.4-24.5-24.4H45.5 c-0.1-2.3-0.1-4.7,0-7c0.5-2.9,2.9-5.1,5.8-5.3c0.8-0.1,1.7,0,2.6,0h147.8c6.3,0,8.5,2.2,8.5,8.5v101.7 C210.3,140.2,208.3,142.2,201,142.2z"
              />
            </svg>
            <p class="mb-0 header-item--text semi-bold" style="cursor: pointer" (click)="openSuggestionSystem()">Sugerencias de sistema</p>
          </li>
          <li
            *ngIf="executiveData"
            class="nav-item px-3 align-items-center d-flex"
            (click)="sidebardSupport()"
            style="gap: 5px; margin: 5px 0px; border-left: 1px solid #ffffff"
          >
            <svg
              class="header-item--icon"
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 300 300"
              style="width: 25px; height: 25px"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M256.9,148.5v30.7c0,16.4-9.4,29.9-20.9,29.9h-6.3v10.5c0,18-14.7,32.7-32.7,32.7h-9.5c-1.3,5.3-6.1,9.2-11.7,9.2h-22.3 c-6.6,0-12.1-5.4-12.1-12.1v-5.1c0-6.6,5.4-12.1,12.1-12.1h22.3c5.6,0,10.4,3.9,11.7,9.1h9.5c12,0,21.7-9.8,21.7-21.7v-10.5h-10.1 c-3.4,0-6.2-3.9-6.2-8.8v-72.9c0-4.9,2.8-8.8,6.2-8.8h1.5v-4c0-28.2-22.9-51.1-51.1-51.1h-16c-28.2,0-51.1,22.9-51.1,51.1v4h0.5 c3.4,0,6.2,4,6.2,8.8v72.9c0,4.9-2.8,8.8-6.2,8.8H65c-11.5,0-20.9-13.5-20.9-29.9v-30.7c0-16.4,9.4-29.9,20.9-29.9h2.5v-4 c0-41.6,33.9-75.5,75.5-75.5h16c41.6,0,75.5,33.9,75.5,75.5v4h1.5C247.4,118.6,256.9,132.1,256.9,148.5z"
                />
              </g>
            </svg>
            <p class="mb-0 header-item--text semi-bold" style="cursor: pointer">Atención al cliente</p>
          </li>

          <div class="sidebar-right" style="background-color: white" [class.show]="sidebarSuggestionSystem">
            <div
              class="d-flex justify-content-end pr-2 align-items-center"
              style="height: 48px"
              [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
            >
              <button
                (click)="closeSuggestionSystem()"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="false"
                style="background-color: transparent; border: none; font-size: 30px; font-weight: 400; color: white"
              >
                x
              </button>
            </div>

            <form
              *ngIf="formSuggestionSystem"
              style="padding-left: 1.75em; padding-right: 1.75em"
              [formGroup]="formSuggestionSystem"
              (ngSubmit)="sendSuggestionSystem()"
            >
              <h2 class="mb-0 section-title mt-4" style="line-height: 1; padding-bottom: 0px">Envía tu sugerencia</h2>
              <p
                class="mb-4"
                style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 400; line-height: 1; color: #8b8b8b"
              >
                Ayudanos a mejorar tu experiencia de reservas...
              </p>

              <div class="mb-3 d-flex flex-column" style="width: 100%; position: relative">
                <label class="ml-2 custom-label" for="module">Módulo</label>
                <select
                  formControlName="module"
                  name="module"
                  class="form-control custom-input form-select custom-select-arrow"
                  style="border: 1px solid black"
                  id="module"
                >
                  <option value="null" selected disabled>Seleccione un módulo</option>
                  <ng-container *ngFor="let module of availableModules">
                    <option value="{{ module.label }}">{{ module.label }}</option>
                  </ng-container>
                  <option value="Otro">Otro...</option>
                </select>
                <span
                  style="
                    position: absolute;
                    top: 65%;
                    right: 1em;
                    width: 0;
                    height: 0;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                  "
                  [ngStyle]="{ 'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                ></span>
              </div>

              <div class="mb-3 d-flex flex-column" style="width: 100%">
                <label class="ml-2 custom-label" for="title">Título</label>
                <input
                  formControlName="title"
                  type="text"
                  class="form-control custom-input"
                  placeholder="voucher sin poder emitir"
                  maxLength="30"
                />
                <p class="mb-0 ml-2 custom-counter">
                  {{
                    formSuggestionSystem.get("title")?.value && formSuggestionSystem.get("title")?.value?.length > 0
                      ? formSuggestionSystem.get("title")?.value?.length
                      : 0
                  }}/30 carácteres como máximo
                </p>
              </div>

              <div class="d-flex flex-column" style="width: 100%">
                <label class="ml-2 custom-label" for="description">Descripción</label>
                <textarea
                  formControlName="description"
                  name="description"
                  rows="5"
                  cols="33"
                  class="form-control custom-textarea"
                  placeholder="¿Qué esperabas?¿Qué ocurrió?¿donde ocurrió? Ej. En el file 135, al generar el voucher el botón 'descargar voucher' estaba deshabilitado. Esperaba ver el botón activo."
                  maxLength="200"
                  id="description"
                >
                </textarea>
                <p class="mb-0 ml-2 custom-counter">
                  {{
                    formSuggestionSystem.get("description")?.value && formSuggestionSystem.get("description")?.value.length > 0
                      ? formSuggestionSystem.get("description")?.value.length
                      : 0
                  }}/200 carácteres como máximo
                </p>
              </div>

              <div class="d-flex align-items-center" style="gap: 0.5em; margin-top: 1.75em; margin-bottom: 1.75em">
                <input type="checkbox" class="black-checkbox" formControlName="contact_available" />
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-weight: 600; font-size: 16px">Quiero que me contacten</p>
              </div>

              <div class="d-flex justify-content-end" style="gap: 0.5em">
                <button type="button" class="btn btn-continue" style="background-color: #ececec" (click)="resetFormSuggestionSysytem()">
                  Borrar
                </button>
                <button
                  type="submit"
                  class="btn btn-continue"
                  [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>

          <div class="sidebar-right" style="background-color: white" [class.show]="sidebarSupportShow">
            <div
              class="d-flex justify-content-end pr-2 align-items-center"
              style="height: 48px"
              [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
            >
              <button
                (click)="closeSidebardSupport()"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="false"
                style="background-color: transparent; border: none; font-size: 30px; font-weight: 400; color: white"
              >
                x
              </button>
            </div>

            <ul style="list-style: none; padding: 1rem">
              <div *ngIf="executiveData" class="executive-profile">
                <!-- Avatar con fallback accesible -->
                <h2 class="section-title">Atención al cliente 24/7</h2>
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 400; line-height: 1; margin-bottom: 5px"
                >
                  ¿Necesitas asistencia?
                </p>
                <p style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 400; line-height: 1">
                  Estamos listos para atenderte
                </p>

                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 400; line-height: 1; color: #6c6b72"
                >
                  Mejora tu experiencia con apoyo experto
                </p>
                <p style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 600; line-height: 1">Tú ejecutivo de ventas</p>

                <div class="d-flex flex-column pt-4 pb-2" style="background-color: #e8e8e9; border-radius: 8px">
                  <div class="d-flex align-items-center px-5 mb-3" style="gap: 2em">
                    <div style="width: 40%" style="position: relative">
                      <!-- <div class="avatar-container"  > -->
                      <div
                        style="position: relative; width: 100px; height: 100px"
                        role="img"
                        [attr.aria-label]="'Foto de perfil de ' + executiveData.first_name"
                      >
                        <!-- Imagen de fondo (la forma) - siempre visible -->
                        <img
                          src="../../../../assets/img/forma_ejecutivo-01.png"
                          style="width: 100px; height: 100px; position: absolute; top: 0; left: 0; z-index: 1"
                          alt=""
                        />

                        <!-- Imagen de perfil (se superpone a la forma) - solo si existe -->
                        <img
                          *ngIf="executiveData.image_profile"
                          [src]="bookingApiStorage + executiveData.image_profile"
                          alt=""
                          style="
                            width: 100px;
                            height: 100px;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 2;
                            object-fit: cover;
                            border-radius: 50%;
                          "
                        />
                      </div>
                      <img
                        src="../../../../assets/icons/general/camara_de_video.svg"
                        tooltip="{{ urlSafe ? 'Video de presentación' : 'El ejecutivo de ventas no cuenta con video de presentación' }}"
                        placement="bottom"
                        style="width: 23px; cursor: pointer; position: absolute; bottom: 3px; right: 0px"
                        (click)="openVideoModal(urlSafe)"
                        alt=""
                      />
                    </div>
                    <div style="width: 60%">
                      <p style="font-family: &quot;Rubik&quot;, serif; font-size: 15px; font-weight: 600; line-height: 1; text-wrap: auto">
                        {{ executiveData.first_name }} {{ executiveData.last_name }}
                      </p>
                      <p style="font-family: &quot;Rubik&quot;, serif; font-size: 15px; font-weight: 400; line-height: 1">
                        <a href="#" (click)="openWhatsApp()" style="color: black; text-decoration: none; cursor: pointer; margin: 0px">
                          + {{ executiveData.phone_code_wsp }} {{ executiveData.wsp_phone_number }}
                        </a>
                      </p>
                      <div>
                        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; font-weight: 400; line-height: 1">
                          Email:
                        </p>
                        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; font-weight: 400; line-height: 1">
                          <a href="#" (click)="openEmailWithSubject($event, true)" style="color: black; text-decoration: none; margin: 0px">
                            {{ executiveData.email }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="px-5 pb-4">
                      <select (change)="executiveHelpSelected($event.target.value)" class="form-control" name="" id="" style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;">
                        <option value="null" disabled="true" selected style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;">¿Cómo puede ayudarte el ejecutivo de ventas?</option>
                        <ng-container *ngFor="let info of infos">
                          <option style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400;" value="{{info}}">{{info}}</option>
                        </ng-container>
                      </select>
                    </div> -->
                </div>
              </div>

              <div class="custom-accordion">
                <!-- Acordeón principal -->
                <div class="accordion-item" [class.expanded]="isMainExpandedExcutiveAction">
                  <div
                    class="accordion-header"
                    [ngStyle]="{ 'border-radius': !isMainExpandedExcutiveAction ? '8px' : '8px 8px 0 0 ' }"
                    (click)="toggleMainAccordionExcutiveAction()"
                    [style.background-color]="'#e8e8e9'"
                  >
                    <span class="mb-0 accordion-title ml-2">¿Cómo puede ayudarte el ejecutivo de ventas?</span>
                    <span class="accordion-icon" [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1">{{
                      isMainExpanded ? "▼" : "▲"
                    }}</span>
                  </div>

                  <div
                    class="accordion-content p-3"
                    style="background-color: #e8e8e9; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px"
                    *ngIf="isMainExpandedExcutiveAction"
                  >
                    <div class="d-flex flex-wrap" style="gap: 12px 20px">
                      <ng-container *ngFor="let info of infos; let i = index">
                        <div class="d-flex align-items-start" style="width: calc(50% - 10px); gap: 0.25em">
                          <i
                            class="bi bi-check-lg"
                            style="line-height: 1"
                            [ngStyle]="{ color: getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                          ></i>
                          <p
                            class="mb-0"
                            style="
                              font-family: &quot;Rubik&quot;, serif;
                              font-size: 13px;
                              font-weight: 400;
                              line-height: 1.2;
                              text-wrap: auto;
                              margin-top: 1px;
                            "
                          >
                            {{ info }}
                          </p>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-accordion">
                <!-- Acordeón principal -->
                <div class="accordion-item" [class.expanded]="isMainExpanded">
                  <div class="accordion-header" (click)="toggleMainAccordion()" [style.background-color]="'#f2fbf7'">
                    <span class="mb-0 accordion-title ml-2">Contactos de otros departamentos</span>
                    <span class="accordion-icon" [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1">{{
                      isMainExpanded ? "▼" : "▲"
                    }}</span>
                  </div>

                  <div class="accordion-content mt-3" *ngIf="isMainExpanded">
                    <!-- Acordeones secundarios -->
                    <div class="nested-accordion">
                      <ng-container *ngFor="let segment of segmentClient; let i = index">
                        <div class="accordion-item mb-2" [class.expanded]="expandedSegment === i">
                          <div class="accordion-header nested-header" (click)="toggleSegment(i)">
                            <span class="accordion-title ml-2">{{ segment.title }}</span>
                            <span class="accordion-icon" [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1">{{
                              expandedSegment === i ? "▼" : "▲"
                            }}</span>
                          </div>

                          <div class="accordion-content nested-content ml-2" *ngIf="expandedSegment === i">
                            <div class="content-body">
                              <p
                                class="mb-4"
                                style="
                                  font-family: &quot;Rubik&quot;, serif;
                                  font-size: 13px;
                                  font-weight: 400;
                                  line-height: 1;
                                  text-wrap: auto;
                                "
                              >
                                {{ segment.description }}
                              </p>

                              <div class="d-flex flex-column pb-4" style="border-bottom: 1px dashed #919191">
                                <ng-container *ngFor="let contact of segment.contacts">
                                  <p
                                    class="mb-4"
                                    style="
                                      font-family: &quot;Rubik&quot;, serif;
                                      font-size: 13px;
                                      font-weight: 400;
                                      line-height: 1;
                                      text-wrap: auto;
                                    "
                                  >
                                    Horarios: {{ contact.schedule }}
                                  </p>

                                  <div class="d-flex mb-3">
                                    <div class="d-flex flex-column" style="width: 100%">
                                      <p
                                        class="mb-1"
                                        style="
                                          font-family: &quot;Rubik&quot;, serif;
                                          font-size: 12px;
                                          font-weight: 400;
                                          line-height: 1;
                                          color: #6c6b72;
                                        "
                                      >
                                        Email
                                      </p>

                                      <span *ngFor="let email of contact.emails">
                                        <!-- <a class="mb-0 mt-0" style="font-family: 'Rubik', serif;font-size: 15px; font-weight: 400;line-height: 1;text-wrap: auto;"
                          [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1" [href]="'mailto:' + email">{{email}}</a>  -->

                                        <a
                                          href="#"
                                          (click)="openEmailWithSubject($event, false)"
                                          [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1"
                                          class="mb-0 mt-0"
                                          style="
                                            font-family: &quot;Rubik&quot;, serif;
                                            font-size: 15px;
                                            font-weight: 400;
                                            line-height: 1;
                                            text-wrap: auto;
                                            margin-bottom: 5px !important;
                                          "
                                        >
                                          {{ email }}
                                        </a>
                                      </span>
                                    </div>

                                    <div class="d-flex flex-column" style="width: 100%">
                                      <p
                                        class="mb-1"
                                        style="
                                          font-family: &quot;Rubik&quot;, serif;
                                          font-size: 12px;
                                          font-weight: 400;
                                          line-height: 1;
                                          color: #6c6b72;
                                        "
                                      >
                                        Teléfono/whatsapp
                                      </p>
                                      <p
                                        class="mb-0"
                                        style="
                                          font-family: &quot;Rubik&quot;, serif;
                                          font-size: 15px;
                                          font-weight: 400;
                                          line-height: 1;
                                          text-wrap: auto;
                                        "
                                        [style.color]="getClientsSettingAppBooking?.clients_setting_global?.color_main_1"
                                      >
                                        {{ contact.phone }}
                                      </p>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                              <div *ngIf="(!segment.contacts || segment.contacts.length === 0) && !segment.description" class="no-content">
                                No hay información disponible para este departamento.
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <div style="height: 110px" [ngStyle]="{'background-color': sectionHeader?.top_header || 'white'}">
    <div class="d-flex justify-content-between w-100 mx-auto" style="height: 55px; max-width: 1440px;">
      <div class="d-flex align-items-center">
        <!-- Botón para abrir sidebar -->
        <button class="btn" (click)="openSidebar()">
          <i [ngStyle]="{ color: sectionHeader?.color }" class="bi bi-list" style="font-size: 2rem; -webkit-text-stroke-width: 1px"></i>
        </button>

        <!-- Sidebar lateral -->
        <div class="sidebar" [ngStyle]="{ 'background-color': sectionHeader?.background_header }" [class.show]="sidebarVisible">
          <ul style="list-style: none; padding-left: 0px !important">
            <li role="menuitem">
              <button
                (click)="closeSidebar()"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="false"
                class="btn btn-outline-light btn-sm mb-4 mt-3"
              >
                <i class="fas fa-times"></i>
              </button>
            </li>
            <li class="dropdown-separador"></li>
            <ng-container *ngFor="let item of items">
              <ng-container *ngIf="(!item.permissionKey || permissionsMap[item.permissionKey]) && item.client">
                <li role="menuitem">
                  <p class="dropdown-item mb-0" style="cursor: pointer" (click)="item.action()">
                    {{ item.label }}
                  </p>
                </li>
                <li *ngIf="item.dividerAfter" class="divider dropdown-divider"></li>
              </ng-container>
            </ng-container>
          </ul>
        </div>

        <!-- Fondo oscuro -->
        <div class="overlay" [class.show]="sidebarVisible" (click)="closeSidebar()"></div>

        <div class="flex-grow-1" style="width: 190px">
          <img
            src="{{ routeUploadFile + getClientsSettingAppBooking?.logo_path_one }}"
            alt="Logo Booking"
            class="d-block logo-booking"
            style="cursor: pointer; width: 100%; max-height: auto; aspect-ratio: 2/1; object-fit: contain"
            (click)="_home()"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end" style="width: 75%">
        <div
          class="d-flex flex-column justify-content-center px-3"
          style="border-bottom-left-radius: 20px"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
        >
          <div class="d-flex align-items-center">
            <img src="../../../../assets/icons/header/wsp.svg" style="width: 18px" alt="" />
            <p
              [ngStyle]="{ color: sectionHeader?.color }"
              class="font-menu datos-header-right mb-0 ml-1"
              style="font-size: 12px !important; font-weight: 400"
            >
              Contacto directo
            </p>
          </div>
          <a
            href="https://wa.me/{{ wsp_number }}"
            target="_blank"
            rel="noopener noreferrer"
            [ngStyle]="{ color: sectionHeader?.color }"
            style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 600"
            >&nbsp;{{ getClientsSettingAppBooking?.wsp_phone_number }}</a
          >
        </div>
        <div *appAgencyOnly class="d-flex flex-column justify-content-center pl-3 pr-5" style="background-color: #f3f5f5; border-right: 1px solid white">
          <div class="d-flex align-items-center">
            <div
              class="d-flex flex-column"
              tooltip="Saldo blickoins"
              style="cursor: pointer"
              *ngIf="!permissionsMap['booking.ingresosinagencia']"
              (click)="goTo('pointxagent')"
              placement="bottom"
            >
              <p
                [ngStyle]="{ color: sectionHeader?.color }"
                class="font-menu datos-header-right mb-0"
                style="font-size: 12px !important; font-weight: 400"
              >
                Rewards
              </p>
              <div class="d-flex align-items-center pr-4" style="border-right: 2px solid white">
                <img src="../../../../assets/icons/header/bks.svg" style="width: 20px" alt="" />
                <p
                  class="mb-0 ml-1"
                  [ngStyle]="{ color: sectionHeader?.color }"
                  (click)="goTo('pointxagent')"
                  style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 600"
                >
                  BKS {{ userService.balanceBlickoins ? (userService.balanceBlickoins | number: "1.2-2") : 0 }}
                </p>
              </div>
            </div>

            <div
              class="d-flex flex-column"
              tooltip="Créditos blickoins"
              style="cursor: pointer"
              (click)="goTo('pointxagent')"
              placement="bottom"
            >
              <p
                [ngStyle]="{ color: sectionHeader?.color }"
                class="font-menu datos-header-right mb-0 pl-2"
                style="font-size: 12px !important; font-weight: 400"
              >
                Wallet
              </p>
              <div class="d-flex align-items-center pl-2 pr-4" style="border-right: 2px solid white">
                <img src="../../../../assets/icons/header/wallet.svg" style="width: 18px" alt="" />
                <p
                  class="mb-0 ml-1"
                  [ngStyle]="{ color: sectionHeader?.color }"
                  style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 600"
                >
                  U$D {{ userService.creditBlickoins | number: "1.2-2" }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-column" tooltip="Límite de crédito" placement="bottom">
              <p
                [ngStyle]="{ color: sectionHeader?.color }"
                class="font-menu datos-header-right mb-0 pl-2"
                style="font-size: 12px !important; font-weight: 400"
              >
                &nbsp;
              </p>
              <div class="d-flex align-items-center pl-2">
                <img src="../../../../assets/icons/header/creditLimit.svg" style="width: 20px; height: 18px" alt="" />
                <p
                  [ngStyle]="{ color: sectionHeader?.color }"
                  class="mb-0 ml-1"
                  style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 600"
                >
                  {{ currencyAgency?.code }} {{ userService?.creditLimits | number: "1.2-2" }} LC
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center pl-5" style="background-color: #f3f5f5">
          <div class="pr-3">
            <p
              class="mb-0"
              style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 400; color: black"
            >
              Fecha
            </p>
            <p
              class="mb-0"
              style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 600; color: black"
            >
              {{ fechaa }}
            </p>
          </div>
          <div *appAgencyOnly class="px-3">
            <p
              [ngStyle]="{ color: sectionHeader?.color, cursor: permissionsMap['booking.ingresosinagencia'] ? 'pointer' : 'default' }"
              tooltip="{{ permissionsMap['booking.ingresosinagencia'] ? 'Cambiar agencia' : '' }}"
              (click)="changeAgencyActive()"
              placement="bottom"
              class="mb-0"
              style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 400"
            >
              Agencia {{ agencyName }}
            </p>
            <p
              [ngStyle]="{ color: sectionHeader?.color }"
              class="mb-0"
              style="font-family: &quot;Poppins&quot;; font-size: 12px; font-weight: 600"
            >
              {{ username }}
            </p>
          </div>
          <div *appAgencyOnly class="d-flex" style="gap: 0.5em">
            <div style="width: 38px; height: 38px; border-radius: 50%; border: 2.5px solid white">
              <img
                *ngIf="agencyImagen"
                class="imag-circle"
                [src]="agencyImagen"
                alt="Logo Agency"
                tooltip="{{ permissionsMap['booking.ingresosinagencia'] ? 'Cambiar agencia' : '' }}"
                placement="bottom"
                [ngStyle]="{ cursor: permissionsMap['booking.ingresosinagencia'] ? 'pointer' : 'default' }"
                (click)="changeAgencyActive()"
              />
            </div>
            <div *appAgencyOnly class="mt-1" style="height: 34px; background-color: black; width: 3px"></div>
            <button *appAgencyOnly type="button" class="close mt-1 pr-3" (click)="logout()" placement="bottom">
              <i class="bi bi-power" style="font-size: 30px; -webkit-text-stroke-width: 1.2px" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *appAgencyOnly  >
       <div
    [ngStyle]="{
      visibility: permissionsMap['booking.itinerarios.crear'] ? 'visible' : 'hidden',
      'background-color': sectionHeader?.top_header
    }"
    id="section-bottom"
    [ngClass]="{ 'hidden-section': shouldHideSection() }"
  >
    
    <usb-itinerary-owner
      *ngIf="currencyAgency"
      [getClientsSettingAppBooking]="getClientsSettingAppBooking"
      [currencyAgency]="currencyAgency"
      [currencies]="currencies"
    ></usb-itinerary-owner>
  </div>
  </ng-container>
 
</header>
